<section id="why-nep-prop">
    <h2 class="text-center mb-4"><strong>Why Nepal Property?</strong></h2>
    <p class="py-5 custom-text-1">Nepal's leading property site with thousands of properties for sale and rent. Search our site every month for your residential and commercial real estate needs. We take pride in our extensive client and investor database, which we will use to find a suitable buyer or tenant for your property.
    </p>
    <div class="contents">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4 mb-2">
                <div class="prop-contents">
                    <div class="cont-icon">
                        <img src="assets\advice.png">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title">
                            <strong>Free Expert Advice</strong>
                        </p>
                        <p style="font-size: medium;">Professional Property Advisors</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mb-2">
                <div class="prop-contents">
                    <div class="cont-icon">
                        <img src="assets/sell.png">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title">
                            <strong>Selling | Renting | Sharing</strong>
                        </p>
                        <p style="font-size: medium;">Made Simple</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mb-2">
                <div class="prop-contents">
                    <div class="cont-icon">
                        <img src="assets/city.png">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title">
                            <strong>Associate Advisors</strong>
                        </p>
                        <p style="font-size: medium;">In Your City</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mb-2">
                <div class="prop-contents">
                    <div class="cont-icon">
                        <img src="assets/connected.png">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title">
                            <strong>Get Connected Quickly</strong>
                        </p>
                        <p style="font-size: medium;">Get The Best Deals</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mb-2">
                <div class="prop-contents">
                    <div class="cont-icon">
                        <img src="assets/site.png">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title">
                            <strong>Free Site Visit</strong>
                        </p>
                        <p style="font-size: medium;">At a Time Convenient For You</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mb-2">
                <div class="prop-contents">
                    <div class="cont-icon">
                        <img src="assets/assistance.png">
                    </div>
                    <div class="cont-caption">
                        <p class="caption-title">
                            <strong>24/7 Assistance</strong> 
                        </p>
                        <p style="font-size: medium;">During The Entire Purchase Process</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
